import { FlexBox, SelectableCard } from '@airship-platform/jam-web/components';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { NavigationAction } from './models/proposalNavigation.models';

interface JumpToSectionProps {
  navItems: NavigationAction[];
}

const ToolkitSection: React.FC<JumpToSectionProps> = ({ navItems }) => (
  <FlexBox px={2} flexDirection={'column'} gap={2}>
    <Typography variant={'h2'}>Toolkit</Typography>

    <Box
      sx={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: ['1fr', '1fr 1fr'],
        gap: 2,
      }}
    >
      {navItems.map((action) => (
        <SelectableCard key={action.label} onClick={action.onClick}>
          <FlexBox
            height={28}
            width={28}
            alignItems="flex-start"
            justifyContent="center"
          >
            {action.icon}
          </FlexBox>
          <Typography variant={'body2'}>{action.label}</Typography>
          <Chip size="small" {...action.chipProps} />
        </SelectableCard>
      ))}
    </Box>
  </FlexBox>
);

export default ToolkitSection;
